import { Component, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { FileClass } from './file.class';
import { FileViewBase } from './file.view.directive';
import { EXIF } from 'exif-js';

@Component({
  selector: 'file-view-image',
  template: `
    <div #imagewrapper style="height: 100%;">
      <ngx-imageviewer [src]="fileblob" [width]="canvasDim.width" [height]="canvasDim.height"></ngx-imageviewer>
    </div>
  `
})
export class FileViewImageComponent extends FileViewBase implements OnInit, AfterViewInit {
  public fileblob: any;
  @ViewChild('imagewrapper') wrapper: ElementRef;
  private _canvasDim = { width: 10, height: 10 };

  ngOnInit() {
    this.irs.wait();
    this.loadFileBlob();
  }

  fileLoaded(blob: any) {
    if (typeof(File) !== 'undefined') {
      let name = this.file.name;
      let ext1 = this.file.getExtension();
      let ext2 = this.hasExtension(name);
      if (ext1 !== ext2 && ext1) {
        name += '.'+ext1;
      }
      if (!this.rotateImage(blob, name) && (window.URL)) {
        this.setFileData(blob, name);
      }
    }
    super.fileLoaded(blob);
  }

  ngAfterViewInit() {
  }

  resized(event) {
    this.updateCanvasDim();
  }

  get canvasDim() {
    return this._canvasDim;
  }

  private rotateImage(fileblob: any, name: string) {
    let mime = this.file.mime;
    switch(mime) {
      case 'image/jpeg':
      case 'image/jpg':
      case 'image/pjpeg':
        let _self = this;
        EXIF.getData(fileblob, function() {
          let all = EXIF.getAllTags(this);
          if (typeof(all.Orientation) !== 'undefined' && (all.Orientation != 1 && all.Orientation != null)) {
            _self.transformImage.call(_self, fileblob, name, all.Orientation, all.PixelXDimension, all.PixelYDimension);
          } else {
            _self.setFileData(fileblob, name);
          }
        });
        return true;
      default:
        this.setFileData(fileblob, name);
        return true;
    }
  }

  private transformImage(fileblob: Blob, name: string, orientation: number, width_x: number, height_y: number) {
    let width = width_x;
    let height = height_y;
    let canvas = document.createElement('canvas');
    let ctx = canvas.getContext("2d");
    if (orientation > 4 && orientation < 9) {
      canvas.width = height;
      canvas.height = width;
    } else {
      canvas.width = width;
      canvas.height = height;
    }
    switch (orientation) {
      case 2:
        ctx.transform(-1, 0, 0, 1, width, 0);
        break;
      case 3:
        ctx.transform(-1, 0, 0, -1, width, height );
        break;
      case 4:
        ctx.transform(1, 0, 0, -1, 0, height );
        break;
      case 5:
        ctx.transform(0, 1, 1, 0, 0, 0);
        break;
      case 6:
        ctx.transform(0, 1, -1, 0, height , 0);
        break;
      case 7:
        ctx.transform(0, -1, -1, 0, height , width);
        break;
      case 8:
        ctx.transform(0, -1, 1, 0, 0, width);
        break;
    }
    let img = document.createElement('img');
    let file = new File([fileblob], name, {type: this.file.mime});
    let creator = window.URL;
    img.onload = () => {
      ctx.drawImage(img, 0, 0, width, height);
      canvas.toBlob((blob) => {
        this.setFileData(blob, name);
      });
    };
    img.src = creator.createObjectURL(fileblob);
  }

  private updateCanvasDim() {
    if (this.file.type !== 'image') {
      return false;
    }
    const el = this.wrapper && this.wrapper.nativeElement ? this.wrapper.nativeElement : null;
    if (el && (el.offsetWidth !== this._canvasDim.width || el.offsetHeight !== this._canvasDim.height)) {
      const newDim = { width: el.offsetWidth - 2, height: el.offsetHeight - 2 };
      setTimeout(() => this._canvasDim = newDim, 0);
    }
  }

  private setFileData(blob, name: string) {
    let file = new File([blob], name, {type: this.file.mime});
    this.fileblob = file;
    this.updateCanvasDim();
    this.irs.done();
  }

  private hasExtension(name: string) {
    let ext = name.split('.');
    if (!ext.length) {
      return '';
    }
    return ext[ext.length - 1];
  }
}



// WEBPACK FOOTER //
// ./src/app/file.view.image.component.ts